module.exports = __webpack_public_path__ + "static/media/AddCard.10010b46.svg";